// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-menu__content.menuable__content__active{box-shadow:none;border:1px solid #63666a!important;border-top:none!important}", ""]);
// Exports
module.exports = exports;
